import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { productsJsmStorageManagementResource } from '@jira/router-resources__products-jsw-storage-management/src/productsJswStorageManagementResource.tsx';
import { productsJsmStorageManagementRoute } from '@jira/router-routes__products-jsm-storage-management-routes/src/productsJsmStorageManagementRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { productsJsmStorageManagementEntryPoint } from '@jira/spa-apps__admin-pages-products-jsw-storage-management/src/ProductsJsmStorageManagement.entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const entryPoint = createPageEntryPoint({ main: productsJsmStorageManagementEntryPoint });

export const productsJsmStorageManagementRouteEntry: Route = createEntry(
	productsJsmStorageManagementRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.jsm-configuration.storage-management',
		entryPoint() {
			return fg('jsmgrowth-267_-_enforce_storage_limits') ? entryPoint : notFoundPageEntrypoint;
		},
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			productsJsmStorageManagementResource,
		],

		meta: {
			reporting: {
				id: 'productsJsmStorageManagement',
				packageName: 'jiraRouterRoutesProductsJsmStorageManagementEntries',
				teamName: 'jlove-makkuro',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
